import React from "react";
import Button from "@shared/v2/Button";
import TextButton from "@shared/v2/TextButton";
import { ArrowUpRightFromSquareSolidV6 } from "@shared/v2/Icomoon";
import ZoomCard from "./shared/ZoomCard";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

const BrivityLeadsCard = () => {
  const isPlace = useIsPlace();
  return (
    <ZoomCard
      actions={
        <>
          <Button
            size="medium"
            schema="secondary"
            className="tw-flex tw-items-center tw-gap-[4px]"
            onClick={() => {
              if (isPlace) {
                window.open("https://meetings.hubspot.com/amy-gerrish/place-leads-consult", "_blank");
              }
            }}
          >
            Get More Leads <ArrowUpRightFromSquareSolidV6 />
          </Button>
          <TextButton
            className="tw-px-0 tw-flex tw-items-center tw-gap-[4px]"
            size="medium"
            onClick={() => {
              window.open("https://www.brivity.com/real-estate-leads", "_blank");
            }}
          >
            Learn More <ArrowUpRightFromSquareSolidV6 />
          </TextButton>
        </>
      }
      onClick={() => {
        window.open("https://www.brivity.com/real-estate-leads", "_blank");
      }}
      title="Brivity Leads"
      description="Make it easier to connect with your leads, gain insight into your marketing campaigns, and understand your ROI like never before."
      imgSrc="/images/bg-card-brivity-leads.png"
      imgClassName="tw-mr-[-12px]"
    />
  );
};

export default BrivityLeadsCard;
